<div id="page-skeleton" [class.hide-chrome]="hideChrome">
  @if (this.url !== '' && this.url !== '/') {
    <header id="header-area">
      <section id="top-nav-bar">

        <div>
          <!-- brand logo -->
          <a class="nav-logo" routerLink="/">
            <img alt="" width="37" height="36" src="/assets/wbd.svg">
            <span class="text-gold">GLASS</span>
          </a>
        </div>

        <div>
          <!-- core links -->
          <a pTooltip="GLASSwatch" tooltipPosition="bottom" [tooltipDisabled]="disableNavbarTooltip"
            routerLink="/watch" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
            <span class="material-symbols-rounded nav-icon">videocam</span>
            <div>GLASS<span class="small-caps">watch</span></div>
          </a>
          <a pTooltip="GLASSops" tooltipPosition="bottom" [tooltipDisabled]="disableNavbarTooltip"
            *oktaHasAnyGroup="this.opsRole" routerLink="/ops/v2" routerLinkActive="active">
            <span class="material-symbols-rounded nav-icon">inventory</span>
            <div>GLASS<span class="small-caps">ops</span></div>
          </a>
          <a pTooltip="GLASStools" tooltipPosition="bottom" [tooltipDisabled]="disableNavbarTooltip"
            routerLink="/tools" routerLinkActive="active">
            <span class="material-symbols-rounded nav-icon">contract</span>
            <div>GLASS<span class="small-caps">tools</span></div>
          </a>
          <a pTooltip="GLASScmr" tooltipPosition="bottom" [tooltipDisabled]="disableNavbarTooltip"
            routerLink="/cmr" routerLinkActive="active">
            <span class="material-symbols-rounded nav-icon">rule_settings</span>
            <div>GLASS<span class="small-caps">cmr</span></div>
          </a>
        </div>

        <div>
          <!-- utilities -->
          <a pTooltip="FAQ" tooltipPosition="bottom" [tooltipDisabled]="disableNavbarTooltip"
            routerLink="/faq" routerLinkActive="active">
            <span class="material-symbols-rounded nav-icon">quiz</span>
            <div>FAQ</div>
          </a>
          <!-- <a pTooltip="Documentation" tooltipPosition="bottom" [tooltipDisabled]="disableNavbarTooltip"
            routerLink="/documentation" routerLinkActive="active">
            <span class="material-symbols-rounded nav-icon">unknown_document</span>
            <div>Documentation</div>
          </a> -->
          <div class="h-full">
            <p-divider layout="vertical"></p-divider>
          </div>
          <a pTooltip="Admin" tooltipPosition="bottom" [tooltipDisabled]="disableNavbarTooltip"
            *oktaHasAnyGroup="this.adminRole" routerLink="/admin" routerLinkActive="active">
            <span class="material-symbols-rounded nav-icon">admin_panel_settings</span>
            <div>Admin</div>
          </a>
          <glass-badge class="self-center ml-2"></glass-badge>
        </div>

      </section>
    </header>
  }

  <section id="content-area">
    <section id="main-content">
      <router-outlet></router-outlet>
    </section>
  </section>

  <footer id="footer-area">
    <span>&copy;{{ this.year }} Warner Bros. Discovery. All Rights Reserved.</span>
    @if (this.version) {
      <span>GLASSversion: {{ this.version }}</span>
    }
  </footer>
</div>
